export default "__VITE_ASSET__B6GXto0E__"